import { inject } from '@angular/core';
import { Environment, ENVIRONMENT_TOKEN } from '@shared/models/environment.model';

declare global {
  interface Window {
    adobeDataLayer: Array<any>;
  }
}

export function loadAdobeAnalytics() {
  const env = inject(ENVIRONMENT_TOKEN) as Environment;

  // declare the adobe data layer array so we can interact before the script loads
  // and to have a fallback on local environment
  window.adobeDataLayer = window.adobeDataLayer || [];

  // don't load the adobe analytics script on local environment
  // regardless of selected configuration (dev, opt, prod)
  if (window.location.hostname === 'localhost') {
    return;
  }

  const scriptEl = document.createElement('script');
  scriptEl.setAttribute('async', '');
  scriptEl.src = env.adobeAnalyticsSourceURL;
  document.head.appendChild(scriptEl);
}
